<template>
    <div>
        <b-form @submit="uploadMember($event)">
            <div class="row" ref="formTop">
                <b-card class="col-sm-12 col-md-12 col-lg-6">
                    <b-card-title title-tag="h5" :title="!edit ? 'Add Member' : 'Edit Member'"></b-card-title>
                    <b-card-sub-title v-if="errorMsg.creation" sub-title-tag="div">
                        <span class="text-danger">{{ errorMsg.creation }}</span>
                    </b-card-sub-title>
                    <b-card-body class="px-0">
                        <b-form-group label="Prefix" label-for="prefix">
                            <b-form-input
                                id="prefix"
                                v-model="member.prefix"
                            ></b-form-input>
                            <div
                                v-if="errorMsg.forename"
                                class="invalid-feedback"
                            >{{ errorMsg.forename }}</div>
                        </b-form-group>
                        <b-form-group label="First Name" label-for="firstName">
                            <b-form-input
                                id="firstName"
                                v-model="member.forename"
                                :state="Boolean((member.forename && member.forename.length > 1))"
                            ></b-form-input>
                            <div
                                v-if="errorMsg.forename"
                                class="invalid-feedback"
                            >{{ errorMsg.forename }}</div>
                        </b-form-group>
                        <b-form-group label="Surname" label-for="surname">
                            <b-form-input
                                id="surname"
                                v-model="member.surname"
                                :state="Boolean((member.surname && member.surname.length > 1))"
                            ></b-form-input>
                            <div
                                v-if="errorMsg.surname"
                                class="invalid-feedback"
                            >{{ errorMsg.surname }}</div>
                        </b-form-group>
                        <b-form-group label="Date of Birth" label-for="dob">
                            <b-form-input
                                type="date"
                                show-decade-nav
                                id="dob"
                                v-model="member.dob"
                                :state="Boolean(member.dob && member.dob.length > 2)"
                            ></b-form-input>
                            <div v-if="errorMsg.dob" class="invalid-feedback">{{ errorMsg.dob }}</div>
                        </b-form-group>
                        <b-form-group label="Email Address" label-for="email">
                            <b-form-input
                                if="email"
                                type="email"
                                v-model="member.email"
                                :state="Boolean(member.email) && validateEmail(member.email)"
                            ></b-form-input>
                            <div v-if="errorMsg.email" class="invalid-feedback">{{ errorMsg.email }}</div>
                        </b-form-group>
                        <b-form-group label="Email Address Confirm" label-for="email">
                            <b-form-input
                                if="email"
                                type="email"
                                v-model="email_confirm"
                                :state="Boolean(member.email) && validateEmail(member.email)"
                            ></b-form-input>
                            <div v-if="errorMsg.email" class="invalid-feedback">{{ errorMsg.email }}</div>
                        </b-form-group>
                        <b-form-group label="Phone Number" label-for="phone">
                            <b-form-input
                                id="phone"
                                type="tel"
                                v-model="member.phone"
                            ></b-form-input>
                            <!-- <b-form-input
                                id="phone"
                                type="tel"
                                v-model="member.phone"
                                :state="Boolean(member.phone && member.phone.length > 8)"
                            ></b-form-input> -->
                            <div v-if="errorMsg.phone" class="invalid-feedback">{{ errorMsg.phone }}</div>
                        </b-form-group>
                    </b-card-body>
                </b-card>

                <b-card class="col-sm-12 col-md-12 col-lg-6">
                    <b-card-title title-tag="h5" title="Membership Details"></b-card-title>
                    <b-card-body class="px-0">

                        <b-form-group label="Membership Level" label-for="member_level">
                            <b-form-select
                                id="member_level"
                                v-model="member.member_level_id"
                                :options="memberLevels"
                            ></b-form-select>
                        </b-form-group>
                        <b-form-group
                            label="Membership Expiry"
                            label-for="member_expiry"
                        >
                            <b-form-datepicker
                                show-decade-nav
                                id="member_expiry"
                                v-model="member.member_expiry"
                            ></b-form-datepicker>
                        </b-form-group>
                        <div class="row mb-4">
                            <div class="col-12">UKARA Registered</div>
                            <div class="col-6 text-center">
                                <b-button
                                    block
                                    @click="member.ukara = true"
                                    :variant="member.ukara ? 'primary' : 'outline-primary'"
                                >Yes</b-button>
                            </div>
                            <div class="col-6 text-center">
                                <b-button
                                    block
                                    @click="member.ukara = false"
                                    :variant="member.ukara ? 'outline-primary' : 'primary'"
                                >No</b-button>
                            </div>
                        </div>
                        <b-form-group
                            v-if="member.ukara"
                            label="UKARA Expiry"
                            label-for="ukara_expiry"
                        >
                            <b-form-datepicker
                                show-decade-nav
                                id="ukara_expiry"
                                v-model="member.ukara_expiry"
                            ></b-form-datepicker>
                        </b-form-group>
                    </b-card-body>
                </b-card>

                <b-card class="col-sm-12 col-md-12 col-lg-6">
                    <b-card-title title-tag="h5" title="Address Details"></b-card-title>
                    <b-card-body class="px-0">
                        <b-form-group label="Address Line 1" label-for="address_1">
                            <b-form-input id="address_1" v-model="member.address_1"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Address Line 2" label-for="address_2">
                            <b-form-input id="address_2" v-model="member.address_2"></b-form-input>
                        </b-form-group>
                        <b-form-group label="City" label-for="city">
                            <b-form-input id="city" v-model="member.city"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Region" label-for="region">
                            <b-form-input id="region" v-model="member.region"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Postcode" label-for="postcode">
                            <b-form-input id="postcode" v-model="member.postcode"></b-form-input>
                        </b-form-group>
                    </b-card-body>
                </b-card>

                <b-card class="col-sm-12 col-md-12 col-lg-6">
                    <b-card-title title-tag="h5" title="ICE Details"></b-card-title>
                    <b-card-body class="px-0">
                        <b-form-group label="ICE Name" label-for="ice_name">
                            <b-form-input id="ice_name" v-model="member.ice_name"></b-form-input>
                        </b-form-group>
                        <b-form-group label="ICE Number" label-for="ice_number">
                            <b-form-input type="tel" id="ice_number" v-model="member.ice_number"></b-form-input>
                        </b-form-group>
                        <b-form-group label="ICE Relation" label-for="ice_relation">
                            <b-form-input id="ice_relation" v-model="member.ice_relation"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Conditions" label-for="conditions">
                            <b-form-textarea id="conditions" v-model="member.ice_notes" rows="5"></b-form-textarea>
                        </b-form-group>
                    </b-card-body>
                </b-card>

                <b-card class="col-12 mx-0">
                    <b-card-body class="px-0">
                        <b-button type="submit" variant="primary" block>
                            <template v-if="!edit">
                                Create Member
                            </template>
                            <template v-else>
                                Edit Member
                            </template>
                        </b-button>
                        <b-button v-if="repeatable" @click="uploadMemberRepeat" type="button" variant="primary" block>
                            <template>
                                Add Another Member
                            </template>
                        </b-button>
                    </b-card-body>
                </b-card>
            </div>
        </b-form>
    </div>
</template>

<script>
export default {
    props: {
        memberRaw: {
            default: false,
        },
        edit: {
            default: false,
        },
        returnMember: {
            default: false,
        },
        noEmail: {
            default: false,
        },
        repeatable: {
            default: false,
        },
    },
    data() {
        return {
            sites: null,
            errorMsg: {
                forename: false,
                surname: false,
                dob: false,
                phone: false,
                email: false,
                creation: false,
            },
            member: {
                prefix: null,
                forename: null,
                surname: null,
                dob: null,
                email: null,
                phone: null,
                address_1: null,
                address_2: null,
                city: null,
                region: null,
                postcode: null,
                member_level_id: null,
                member_expiry: null,
                ukara: false,
                ukara_expiry: null,
                ice_name: null,
                ice_number: null,
                ice_relation: null,
                ice_notes: null,
            },
            email_confirm: null,
            memberLevels: [],
        };
    },
    computed: {
        datePickStart() {
            // Return today's date as the start date for the date picker
            return new Date().toISOString().split('T')[0];
        },
    },
    methods: {
        uploadMemberRepeat() {
            if (this.validateData()) {
                    axios
                        .post(this.$routes.route('member.store'), this.member)
                        .then((result) => {
                            if (result.data.success) {
                                // this.returnMember(result.data[0]);
                                this.$emit('memberCreatedRepeat', result.data[0]);
                            } else {
                                this.errorMsg.creation = result.data.msg;
                                this.$refs.formTop.scrollIntoView({
                                    alignToTop: true,
                                    behavior: "smooth",
                                });
                            }
                        })
                        .catch((err) => {
                            this.errorMsg.creation = "Something went wrong, please refresh and try again";
                                this.$refs.formTop.scrollIntoView({
                                    alignToTop: true,
                                    behavior: "smooth",
                                });
                            console.error(err);
                        });
            } else {
                this.$refs.formTop.scrollIntoView({
                    alignToTop: true,
                    behavior: "smooth",
                });
            }
        },
        uploadMember(e) {
            e.preventDefault();
            if (this.validateData()) {
                if (!this.edit) {
                    axios
                        .post(this.$routes.route('member.store'), this.member)
                        .then((result) => {
                            if (result.data.success) {
                                if (this.returnMember) {
                                    // this.returnMember(result.data[0]);
                                    this.$emit('memberCreated', result.data[0]);
                                } else {
                                    window.location.href = `/member/${result.data[0].id}`;
                                }
                            } else {
                                this.errorMsg.creation = result.data.msg;
                                this.$refs.formTop.scrollIntoView({
                                    alignToTop: true,
                                    behavior: "smooth",
                                });
                            }
                        })
                        .catch((err) => {
                            this.errorMsg.creation = "Something went wrong, please refresh and try again";
                                this.$refs.formTop.scrollIntoView({
                                    alignToTop: true,
                                    behavior: "smooth",
                                });
                            console.error(err);
                        });
                } else {
                    axios.post(this.$routes.route('member.update', {'member': this.member.id}), this.member)
                        .then((result) => {
                            if (result.data.success) {
                                window.location.href = `/member/${this.member.id}`;
                            } else {
                                this.errorMsg.creation = result.data.msg;
                                this.$refs.formTop.scrollIntoView({
                                    alignToTop: true,
                                    behavior: "smooth",
                                });
                            }
                        })
                        .catch((err) => {
                            this.errorMsg.creation = "Something went wrong, please refresh and try again";
                                this.$refs.formTop.scrollIntoView({
                                    alignToTop: true,
                                    behavior: "smooth",
                                });
                            console.error("Edit error:", err);
                        })
                }
            } else {
                this.$refs.formTop.scrollIntoView({
                    alignToTop: true,
                    behavior: "smooth",
                });
            }
        },
        validateData() {
            var valid = true;
            if (!this.member.forename || this.member.forename.length < 2) {
                this.errorMsg.forename = "First name is required";
                valid = false;
            }
            if (!this.member.surname || this.member.surname.length < 2) {
                this.errorMsg.surname = "Surname is required";
                valid = false;
            }
            if (!this.member.dob || this.member.dob.length < 2) {
                this.errorMsg.dob = "Date of Birth is required";
                valid = false;
            }

            // if (!this.member.phone || this.member.phone.length < 8) {
            //     this.errorMsg.phone = "Phone number is required";
            //     valid = false;
            // }

            if ((!this.member.email || this.member.email.length < 5 || !this.validateEmail(this.member.email)) && !this.noEmail) {
                this.errorMsg.email = "Email address is invalid";
                valid = false;
            }

            if ((this.member.email !== this.email_confirm) && !this.noEmail) {
                this.errorMsg.email = "Email addresses do not match";
                valid = false;
            }

            return valid;
        },
        validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
    },
    mounted() {
        if (this.memberRaw) {
            this.member = this.memberRaw;
            this.email_confirm = this.member.email;
            // this.member.ice_name = this.member.ice.name;
            // this.member.ice_number = this.member.ice.number;
            // this.member.ice_relation = this.member.ice.relation;
            // this.member.ice_notes = this.member.ice.condition;

            // delete this.member.ice;
        }
        setTimeout(() => {
            axios.get(this.$routes.route("memberlevel.index"))
                .then((result) => {

                    result.data.forEach((level) => {
                        this.memberLevels.push({
                            value: level.id,
                            text: level.title,
                        });
                    });
                });
        }, 100);
    },
};
</script>